import React from "react";

const InPatientContent = {
  checklistText: (
    <React.Fragment>
      <p>
        In-patient NHS cash benefit is not available on all plans. Please check
        your handbook to see if you have cover.
      </p>
      <p>
        This is paid for each night you receive free treatment under the NHS, if
        you're admitted for in-patient treatment before midnight, and the
        treatment would have been eligible under your plan.
      </p>
      <p>Before you start, please have the following ready:</p>
    </React.Fragment>
  ),
  checklist: [
    "Invoices, receipts or bills for your claim",
    "Your hospital discharge summary, if you have it"
  ],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const InPatient = {
  HOL: {
    ...InPatientContent,
    checklistText: (
      <React.Fragment>
        <p>
          In-patient NHS cash benefit is not available on all policies. Please
          check your handbook to see if you have cover.
        </p>
        <p>
          This is paid for each night you receive free treatment under the NHS,
          if you're admitted for in-patient treatment before midnight, and the
          treatment would have been eligible under your policy.
        </p>
        <p>Before you start, please have the following ready:</p>
      </React.Fragment>
    )
  },
  Any: InPatientContent
};

export default InPatient;
